module.exports = {"__schema":{"types":[{"kind":"UNION","name":"SearchResult","possibleTypes":[{"name":"UfvClass"},{"name":"User"}]},{"kind":"INTERFACE","name":"Node","possibleTypes":[{"name":"UfvClass"},{"name":"Review"},{"name":"User"},{"name":"ReviewVotes"}]}]}}


//////////////////
// WEBPACK FOOTER
// ./src/generated/fragmentTypes.json
// module id = 469
// module chunks = 0